/* eslint-disable max-classes-per-file */
import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext } from '@ngxs/store';
import * as _ from 'lodash';
import { forkJoin, tap } from 'rxjs';
import { CommonRdmService } from 'src/app/layout/services/common-rdm.service';
import { LazyLoaderService } from '../services/lazy-loader.service';
import { MenuService } from '../services/menu.service';
import { RDMClientService } from '../services/rdm-client.service';
import { UserInfoService } from '../services/user-info.service';
import {
  AddAttachmentFileType,
  AddModulesPath,
  LazyLoadModuleStatusLoad,
  LoadBaseRdm,
  UserInfo,
  UserSezInfo,
  DashboardToken,
  LoadDeclSchema,
  LoadIntelligenceSchema,
  StandardReportToken,
} from './base.action';
import { DefaultCompanyService } from 'src/app/layout/services/default-company.service';

export interface RdmModuleLoaded {
  rdmList: string[];
  rdmLoading: boolean;
  lazyLoading?: boolean;
}

export class BaseSharedStoreModel {
  attachmentsFileType: any;
  userInfo: any;
  sez: any;
  rdm!: Map<string, any>;
  rdmLoadedForModule!: Map<string, RdmModuleLoaded>;
  dashboardToken:any;
  standardReportToken:any;
}

@State<BaseSharedStoreModel>({
  name: 'baseShared',
  defaults: {
    attachmentsFileType: null,
    userInfo: {},
    sez: {},
    rdm: new Map(),
    rdmLoadedForModule: new Map(),
    dashboardToken:null,
    standardReportToken:null
  },
})
@Injectable()
export class BaseSharedState implements NgxsOnInit {
  baseShared: any;
  listOfRdm: any = [];
  clmList = ["Traders", "Customs Warehouse", 'CustomsBroker'];
  constructor(
    public menuService: MenuService,
    public rdmClient: RDMClientService,
    public userService: UserInfoService,
    public lazyloaderService: LazyLoaderService,
    public commonRdm :CommonRdmService,
    private defaultCompanyService: DefaultCompanyService,
  ) {}

  ngxsOnInit(context?: any) {
    this.userService.getUserInfo$().subscribe( res => {
      context.dispatch(new LoadDeclSchema())
    })
    // this.context.dispatch(new StandardReportToken());
  }

  @Selector()
  public static getRdmData(state: BaseSharedStoreModel) {
    return state.rdm;
  }

  @Selector()
  public static rdmDataLoadedForModule(state: BaseSharedStoreModel) {
    return state.rdmLoadedForModule;
  }

  @Selector()
  public static getAttachementsData(state: BaseSharedStoreModel) {
    return state.attachmentsFileType;
  }

  @Selector()
  public static getUserInfo(state: BaseSharedStoreModel) {
    return state.userInfo;
  }

  @Selector()
  public static getDashboardToken(state: BaseSharedStoreModel) {
    return state.dashboardToken;
  }
  @Selector()
  public static getStandardReportToken(state: BaseSharedStoreModel) {
    return state.standardReportToken;
  }

  // @Selector()
  // public static getBpsTaskInfo(state: BaseSharedStoreModel) {
  //   return state.bps;
  // }

  @Selector()
  public static getSezInfo(state: BaseSharedStoreModel) {
    return state.sez;
  }

  @Selector()
  static getSchema(state: any) {
    return state.schema;
  }

  @Selector()
  static getNewSchema(state: any) {
    return state.new_schema;
  }

  @Action(AddAttachmentFileType)
  addAttachmentFileType(
    context: StateContext<BaseSharedStoreModel>,
    action: AddAttachmentFileType
  ) {
    let attachmentsFileType = context.getState().attachmentsFileType;
    if (attachmentsFileType === null) {
      attachmentsFileType = {};
    }

    attachmentsFileType[action.key] = action.data;
    context.patchState({
      attachmentsFileType: attachmentsFileType,
    });
  }

  @Action(UserInfo)
  userInfo(context: StateContext<BaseSharedStoreModel>, action: UserInfo) {
    const userInfo = context.getState().userInfo;
    userInfo[action.key] = action.data;
    context.patchState({
      userInfo: userInfo,
    });
    if (action.key === 'custom-role') {
      this.menuService.fetchMenus();
    }
  }

  @Action(DashboardToken)
  dashboardToken(context: StateContext<BaseSharedStoreModel>) {
    this.userService.getDashboardToken().subscribe((result: any) => {
      context.patchState({
        dashboardToken: result,
      });
    });
  }

  @Action(StandardReportToken)
  standardReportDashboardToken(context: StateContext<BaseSharedStoreModel>) {
    // this.userService.getStandardReportToken().subscribe((result: any) => {
    //   context.patchState({
    //     standardReportToken: result,
    //   });
    // });
  }

  // @Action(UserBpsTaskInfo)
  // bpsTask(context: StateContext<BaseSharedStoreModel>, action: UserBpsTaskInfo) {
  //   console.log(context.getState())
  //   let bpsInfo = context.getState().bps;
  //   bpsInfo[action.key] = action.data
  //   context.patchState({
  //     bps: bpsInfo
  //   });
  // }

  @Action(UserSezInfo)
  sezinfo(context: StateContext<BaseSharedStoreModel>, action: UserSezInfo) {
    const sezInfo = context.getState().sez;
    sezInfo[action.key] = action.data;
    context.patchState({
      sez: sezInfo,
    });
  }

  @Action(LoadBaseRdm)
  LoadBaseRdm(
    context: StateContext<BaseSharedStoreModel>,
    action: LoadBaseRdm
  ) {
    const state = context.getState();
    let reqRdm: any[] = [];
    if (this.listOfRdm.length === 0) {
      this.listOfRdm = action.rdm;
      reqRdm = _.uniq(action.rdm);
     // this.setRdmLoadedModuleList(context, action.module, reqRdm);
    } else {
      const temp = action.rdm;
      temp.forEach((t) => {
        if (this.listOfRdm.indexOf(t) < 0) {
          this.listOfRdm.push(t);
          reqRdm.push(t);
        }
      });
      //if (reqRdm.length > 0)
      //  this.setRdmLoadedModuleList(context, action.module, reqRdm);
    }
    if (reqRdm.length > 0) {
      this.rdmClient.lodingSubscriber.next(true);
      const localRdm = state.rdm;
      this.clmList.forEach((type) => {
        // if(reqRdm.indexOf(type) >= 0){
        //   const traderBody = { licenseGroup: type, paged: false };
        //   let dropDownData = [];
        //   this.defaultCompanyService.getClmTraders(traderBody).subscribe(
        //     (response: any) => {
        //       dropDownData = response.content || [];
        //       dropDownData.map((item: any) => {
        //         item.label = item.clientName;
        //         item.code = item.accountNo;
        //         return item;
        //       });
        //       localRdm.set(type, dropDownData);
        //     });
        //   }
      });

      this.rdmClient.getAllRdmTypes(reqRdm, action.status).subscribe(
        (res) => {
          reqRdm.forEach((type) => {
            const foundTypes = _.find(res, { label: type });
            if (foundTypes) {
              localRdm.set(type, foundTypes['refValue']);
            } else {
              if (!this.clmList.includes(type)) localRdm.set(type, []);
            }
          });
         // this.sortRdmData(localRdm);
          context.patchState({
            rdm: _.cloneDeep(localRdm),
          });
          this.rdmClient.setRdmData(localRdm);
          this.rdmClient.lodingSubscriber.next(false);
         // this.checkRdmLoadedForModule(context, action);
        },
        (err) => {
          console.log(err);
          this.rdmClient.lodingSubscriber.next(false);
          this.checkRdmLoadedForModule(context, action);
          if (err && err.status === 401)
            this.userService.userLogout('sessiontimeout');
        }
      );
    }
  }

  @Action(AddModulesPath)
  addModulesPath(
    context: StateContext<BaseSharedStoreModel>,
    action: AddModulesPath
  ) {
    const rdmModulesMap = new Map();
    action.modules.forEach((m) => {
      rdmModulesMap.set(m, {
        rdmList: [],
        rdmLoading: false,
        lazyLoading: false,
      });
    });
    // add a static route which is out of business route from app.component.ts
    rdmModulesMap.set('settings', {
      lazyLoading: false,
      rdmList: [],
      rdmLoading: false,
    });
    context.patchState({ rdmLoadedForModule: _.cloneDeep(rdmModulesMap) });
  }

  @Action(LazyLoadModuleStatusLoad)
  lazyLoadModuleStatusLoad(
    context: StateContext<BaseSharedStoreModel>,
    action: LazyLoadModuleStatusLoad
  ) {
    const state = context.getState();
    const rdmLoadModuleList = state.rdmLoadedForModule;
    const oldModuleData = rdmLoadModuleList.get(action.moduleStatus.module);
    console.log(oldModuleData);
    if (oldModuleData) {
      const update = _.cloneDeep(rdmLoadModuleList);
      update.delete(action.moduleStatus.module);
      oldModuleData.lazyLoading = action.moduleStatus.loading;
      update.set(action.moduleStatus.module, oldModuleData);
      console.log(
        'lazyLoadModuleStatusLoad update -> ',
        action.moduleStatus.module,
        ' rdmLoading -> ',
        oldModuleData.rdmLoading,
        ' lazyLoading ->',
        oldModuleData.lazyLoading
      );
      context.patchState({
        rdmLoadedForModule: _.cloneDeep(update),
      });
    }
  }

  setRdmLoadedModuleList(
    context: StateContext<BaseSharedStoreModel>,
    module: string,
    rdmList: string[]
  ) {
    const state = context.getState();
    const rdmLoadModuleList = state.rdmLoadedForModule;
    const oldModuleData: any = rdmLoadModuleList.get(module);
    if (rdmLoadModuleList.has(module)) {
      rdmLoadModuleList.set(module, {
        rdmList: oldModuleData.rdmList.concat(rdmList),
        rdmLoading: true,
        lazyLoading: oldModuleData.lazyLoading,
      });
    } else {
      rdmLoadModuleList.set(module, {
        rdmList: rdmList,
        rdmLoading: true,
        lazyLoading: oldModuleData?.lazyLoading,
      });
    }
    context.patchState({
      rdmLoadedForModule: _.cloneDeep(rdmLoadModuleList),
    });
  }

  checkRdmLoadedForModule(
    context: StateContext<BaseSharedStoreModel>,
    action: LoadBaseRdm
  ) {
    const state = context.getState();
    const rdmList = Array.from(state.rdm.keys());
    const rdmListOfmodules = state.rdmLoadedForModule;
    const oldModuleData: any = rdmListOfmodules.get(action.module);
    oldModuleData.rdmLoading =
      _.intersection(rdmList, oldModuleData.rdmList).length ===
      oldModuleData.rdmList.length
        ? false
        : true;
    rdmListOfmodules.delete(action.module);
    rdmListOfmodules.set(action.module, oldModuleData);
    console.log(
      'checkRdmLoadedForModule -> ',
      action.module,
      ' rdmLoading -> ',
      oldModuleData.rdmLoading,
      ' lazyLoading ->',
      oldModuleData.lazyLoading
    );
    context.patchState({
      rdmLoadedForModule: _.cloneDeep(rdmListOfmodules),
    });
    console.log(state.rdm)
  }

  @Action(LoadDeclSchema)
  LoadDeclSchema(context: StateContext<any>) {
    const allTypes:any=[];
    this.commonRdm.getDeclarationsSchema('new-schema.json').subscribe((res:any)=>{
      allTypes.push(...this.commonRdm.loadrefTypeCode(res),...this.commonRdm.loadparentRefType(res));
      allTypes.push('regimecargotypes')
	  allTypes.push('kc-label-app-modules')
      context.dispatch(new LoadBaseRdm(allTypes, 'schema-ics-declaration'));
    })
  }

  @Action(LoadIntelligenceSchema)
  LoadIntelligenceSchema(context: StateContext<any>) {
    const allTypes:any=[];
    const schemaType = ["ics"];
    const schemaTypeRequest: any[] = [];
    schemaType.forEach((item) => {
      schemaTypeRequest.push(this.commonRdm.getNewSchemaType(item));
    });
    forkJoin(schemaTypeRequest).subscribe((result: any) => {
      const newSchema :any= {
        ics: result[0] ? result[0] : undefined,
      };

      for (const type in newSchema) {
        allTypes.push(...this.commonRdm.loadrefTypeCode(newSchema[type]))
      }
      context.dispatch(
        new LoadBaseRdm(allTypes, "new-schema-intelligencemgmt")
      );
    });
  }

}
